import ClinicalResultsItemModel from './ClinicalResultsItem.model';

export default class ClinicalResults {
  constructor(apiResponse) {
    this.results = apiResponse?.rows || [];
    this.currentPage = apiResponse?.pager?.current_page;
    this.itemsPerPage = apiResponse?.pager?.items_per_page;
    this.totalItems = apiResponse?.pager?.total_items;
    this.totalPages = apiResponse?.pager?.total_pages;
  }

  pushData(rows, page) {
    this.results = [...this.results, ...rows];
    this.currentPage = page;
  }

  getResultsItems() {
    return this.results.map((item) => new ClinicalResultsItemModel(item));
  }

  getCurrentPage() {
    return this.currentPage;
  }

  getItemsPerPage() {
    return this.itemsPerPage || 0;
  }

  getTotalItems() {
    return this.totalItems || 0;
  }

  getTotalPages() {
    return this.totalPages || 0;
  }
}
